import { connect } from 'react-redux';

import HeadMeta from './HeadMeta';
import {
  setTabActive,
  resetNotificationsCount,
} from '../../../../store/actions/general';

const mapStateToProps = state => ({
  volume: state.general.volume,
  notificationsCount: state.general.notificationsCount,
  isNotificationsSoundEnabled: state.general.isNotificationsSoundEnabled,
});

const mapDispatchToProps = {
  setTabActive,
  resetNotificationsCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeadMeta);
